<script>
    import { onMount } from "svelte";
    import Historyback from "../components/Historyback.svelte";

    onMount(() => {
        window.scroll(0, 0);
    });
</script>    

<div class="flex jc-between">
    <h2>特定商取引法に基づく表示</h2>
    <Historyback />
</div>
<h3>■商品販売業者</h3>
<dl class="row">
    <dt class="col two">名称</dt><dd class="col ten">株式会社ＥＶＥＮＴＩＦＹ (イベンティファイ)</dd>
    <dt class="col two">責任者</dt><dd class="col ten">代表取締役社長　井原　義浩</dd>
    <dt class="col two">所在地</dt><dd class="col ten">〒162-0801<br />東京都新宿区山吹町３４７番地<br />藤和江戸川橋ビル６階</dd>
    <dt class="col two">電話番号</dt><dd class="col ten">03-5946-8493<br />お問合せは、「FAQ：お問い合わせ」のお問い合わせフォームよりお問い合わせください。</dd>
</dl>
<h3>■販売価格</h3>
<p>各商品（チケット）販売ごとに掲載します。</p>
<h3>■商品以外の必要代金</h3>
<p>サービス手数料、システム利用料、支払手数料、発券手数料、郵送料その他各商品（チケット）販売ごとに掲載します。</p>
<h3>■支払時期および支払方法</h3>
<p>クレジットカード　ファミリーマート　会場窓口　チケットセンター窓口　銀行振込等その他各商品（チケット）販売ごとに掲載します。</p>
<h3>■引取時期および受取方法</h3>
<p>ファミリーマート　会場窓口　チケットセンター窓口　郵送等その他各商品（チケット）販売ごとに掲載します。</p>
<h3>■引渡時期および有効期限</h3>
<p>受取方法により異なります｡各商品（チケット）販売ごとに記載します。</p>
<h3>■キャンセルと払戻し</h3>
<p class="ws-pl">
購入者の都合による変更、取消し、払戻しは承りません｡
不可抗力による公演延期、中止により払戻しが決定された場合は所定の方法により払戻しをいたします。ただし、チケットを破損・紛失汚損し判別しがたい場合は一切払戻しはいたしません。
払戻しが決定次第、払戻し期間、方法等詳細を、購入者の登録先メールへの配信等にてご連絡いたします。
</p>
<h3>■その他特別の販売条件</h3>
<p>その他の販売条件については利用規約のご参照をお願いいたします｡</p>
<p class="ws-pl">
令和2年11月27日
株式会社ＥＶＥＮＴＩＦＹ
</p>
<div class="flex jc-end">
    <Historyback />
</div>
